import AuthService from '../../../Services/authService';
import OpportunityStatusEnum from '../../../Enums/OpportunityStatusEnum';
import OpportunitySecurityChecklistService from '../../../Services/opportunitySecurityChecklistService';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

// Static description for a Security Checklist completion log (see GeneralEntryLogFigma), reused for Data Transfer
// and Data Erasure. Declares what is unique to a completion panel: the self-fetching entry list, the meta line,
// the confirmation-checkbox add field with its optional note, the immutability (no delete affordance and no backend path for one) and
// the gating. OpportunitySecurityChecklistTab renders both panels and supplies the live context.
export default class OpportunityCompletionEntryLogDescription {
  //#region List
  static title = (ctx) => `${ctx.title} Completions`;
  static errorCode = 'OCELD24';

  // Fetched on their own, scoped to this section's completionType. Nothing to show before the checklist is saved,
  // so the round-trip is skipped.
  static populate = (ctx) =>
    ctx.checklistExists
      ? OpportunitySecurityChecklistService.GetCompletions(ctx.opportunityId, ctx.completionType)
      : Promise.resolve([]);

  static convert = (rows) => OpportunitySecurityChecklistService.ConvertCompletionsDBItem(rows);

  static metaAttribution = {
    attributionPrefix: 'Confirmed by',
    authorNameKey: 'ConfirmedByName',
    timestampKey: 'ConfirmedOnUtc',
    authorIdKey: 'ConfirmedBy',
  };

  static renderBody = (completion, ctx) =>
    completion.Note
      ? `${ctx.title} completion confirmed.\nNote: ${completion.Note}`
      : `${ctx.title} completion confirmed.`;
  //#endregion

  //#region Add
  static addField = {
    type: InputTypesEnum.SingleCheckBox,
    initialValue: false,
    label: (ctx) => ctx.confirmLabel || 'I confirm this step has been completed.',
    placeholder: null,
    isValid: (value) => value === true,
  };

  // Optional: the confirmation alone is enough to save.
  static noteField = {
    type: InputTypesEnum.TextBox2,
    initialValue: '',
    placeholder: 'Add a note (optional)...',
  };

  // The add button stays visible and is greyed out with the first reason that blocks it. The server checks the
  // same three conditions. Whether the section is marked as required deliberately plays no part: an entry may be
  // logged either way.
  static addDisabledReason = (ctx) => {
    if (!ctx.checklistExists) {
      return 'Save the Security Checklist first.';
    }
    if (ctx.statusCode.toString() !== OpportunityStatusEnum.OpportunityWon.toString()) {
      return 'Completion entries can be added once the Opportunity is Won.';
    }
    if (!AuthService.HasRole('OpportunityEdit')) {
      return 'You do not have permission to add completion entries.';
    }
    return null;
  };

  // Single source for the panel's contextual notice (no checklist yet / not-yet-Won / empty).
  static stateMessage = (ctx) => {
    if (!ctx.checklistExists) {
      return 'Save the Security Checklist first.';
    }
    if (ctx.statusCode.toString() !== OpportunityStatusEnum.OpportunityWon.toString()) {
      return 'Completion entries can be added once the Opportunity is Won.';
    }
  };

  static addEntry = (value, ctx, note) =>
    OpportunitySecurityChecklistService.AddCompletion(ctx.opportunityId, ctx.completionType, note);
  //#endregion
}
